if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.deliveryNote = this.querySelector('.js-inventory-delivery');
      this.separator = this.querySelector('.js-inventory-sep');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        this.hidden = false;
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    setSecondaryMessage(html, useHtml) {
      if (!this.deliveryNote || !this.separator) return;

      if (!html) {
        this.deliveryNote.hidden = true;
        this.separator.hidden = true;
        this.deliveryNote.textContent = '';
        return;
      }

      this.deliveryNote.hidden = false;
      this.separator.hidden = false;

      if (useHtml) {
        this.deliveryNote.innerHTML = html;
      } else {
        this.deliveryNote.textContent = html;
      }
    }

    updateInventory(count, available, inventoryPolicy) {
      if (count === 0 && !available && this.hidden) {
        return;
      }

      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;
        this.setAttribute('data-inventory-level', inventoryLevel);

        const inStockLabel = this.dataset.textInStock || theme.strings.inStock;
        let secondaryMessage = '';
        let secondaryIsHtml = false;

        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerHTML = this.dataset.textNoStockBackordered || '';
          this.setSecondaryMessage('', false);
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerHTML = this.dataset.textNoStock || theme.strings.noStock || '';
          this.setSecondaryMessage('', false);
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.textContent = theme.strings.onlyXLeft.replace('[quantity]', count);
          secondaryMessage = this.dataset.textDelivery;
        } else if (inventoryLevel === 'very_low') {
          this.inventoryNotice.textContent = inStockLabel;
          if (this.dataset.showUrgencyMessage === 'true' && this.dataset.textVeryLow) {
            secondaryMessage = this.dataset.textVeryLow;
            secondaryIsHtml = true;
          } else {
            secondaryMessage = this.dataset.textDelivery;
          }
        } else if (inventoryLevel === 'low') {
          this.inventoryNotice.textContent = inStockLabel;
          if (this.dataset.showUrgencyMessage === 'true' && this.dataset.textLow) {
            secondaryMessage = this.dataset.textLow;
            secondaryIsHtml = true;
          } else {
            secondaryMessage = this.dataset.textDelivery;
          }
        } else {
          this.inventoryNotice.textContent = inStockLabel;
          secondaryMessage = this.dataset.textDelivery;
        }

        if (inventoryLevel !== 'backordered' && inventoryLevel !== 'none') {
          this.setSecondaryMessage(secondaryMessage, secondaryIsHtml);
        }

        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
